import classNames from "classnames";
import React from "react";
import styles from "./showMoreDotsIcon.css";

export const ShowMoreDotsIcon = () => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.dot, styles.first)} />
      <div className={classNames(styles.dot, styles.second)} />
      <div className={classNames(styles.dot, styles.third)} />
    </div>
  );
};
